import { Component } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-inline-wrapper',
  templateUrl: './inline-wrapper.component.html',
  styleUrl: './inline-wrapper.component.scss',
  imports: [FormlyModule],
})
export class FormlyInlineWrapperComponent extends FieldWrapper {}
